window.reparacoesData = {
  "nokia-g10": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },

  "nokia-g20": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  }
};
